var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdfToExcel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 161,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9213_1741)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.833 5.32308C142.132 3.94268 161.518 -3.41956 179.807 1.91346C199.063 7.52856 213.456 21.0381 224.973 35.1068C237.051 49.86 251.263 66.8263 247.333 84.3986C243.373 102.109 252.849 117.68 238.895 131.412C227.707 142.423 188.655 150.848 173.216 157.341C157.945 163.763 139.845 160.065 122.833 158.673C107.206 157.395 92.2834 154.685 77.8404 149.537C61.8904 143.852 46.5478 137.385 34.3056 127.121C19.5871 114.781 -1.99131 101.732 0.147587 84.3986C2.34911 66.5579 30.9027 60.5172 44.2568 46.4786C55.1526 35.0243 56.3879 17.4502 71.2232 9.67995C86.1291 1.87278 105.306 6.57666 122.833 5.32308Z",
    fill: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 119.52V42.4796C32.5 40.2686 34.2382 38.5 36.3538 38.5H81.2713L99.4476 57.2014V119.52C99.4476 121.731 97.7094 123.5 95.5938 123.5H36.3538C34.2391 123.5 32.5 121.732 32.5 119.52Z",
    fill: "white",
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.4937,
    y: 95.5,
    width: 50.9602,
    height: 21,
    rx: 2.18571,
    fill: "#D2294B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.4937,
    y: 95.5,
    width: 50.9602,
    height: 21,
    rx: 2.18571,
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8882 110.476V101.524H57.9536C58.9468 101.524 59.7128 101.778 60.2515 102.286C60.7902 102.785 61.0595 103.484 61.0595 104.381C61.0595 105.278 60.7902 105.981 60.2515 106.489C59.7128 106.997 58.9468 107.251 57.9536 107.251H55.8452V110.476H53.8882ZM55.8452 105.727H57.6254C58.6607 105.727 59.1783 105.278 59.1783 104.381C59.1783 103.501 58.6607 103.06 57.6254 103.06H55.8452V105.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2724 110.476V101.524H65.757C67.2721 101.524 68.4463 101.913 69.2796 102.692C70.1129 103.463 70.5295 104.563 70.5295 105.994C70.5295 107.424 70.1129 108.529 69.2796 109.308C68.4463 110.087 67.2721 110.476 65.757 110.476H62.2724ZM64.2293 108.864H65.6434C67.5373 108.864 68.4842 107.907 68.4842 105.994C68.4842 104.089 67.5373 103.137 65.6434 103.137H64.2293V108.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0498 110.476V101.524H78.0596V103.06H74.0068V105.245H77.7818V106.781H74.0068V110.476H72.0498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2065 52.5996V39.236L98.8209 56.411H85.8772C83.8658 56.411 82.2065 54.7209 82.2065 52.5996Z",
    fill: "white",
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 63.5H84C84.8284 63.5 85.5 64.1716 85.5 65V66C85.5 66.8284 84.8284 67.5 84 67.5H48C47.1716 67.5 46.5 66.8284 46.5 66V65C46.5 64.1716 47.1716 63.5 48 63.5Z",
    fill: "#D2294B",
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 73.5H84C84.8284 73.5 85.5 74.1716 85.5 75V76C85.5 76.8284 84.8284 77.5 84 77.5H48C47.1716 77.5 46.5 76.8284 46.5 76V75C46.5 74.1716 47.1716 73.5 48 73.5Z",
    fill: "#D2294B",
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 83.5H84C84.8284 83.5 85.5 84.1716 85.5 85V86C85.5 86.8284 84.8284 87.5 84 87.5H48C47.1716 87.5 46.5 86.8284 46.5 86V85C46.5 84.1716 47.1716 83.5 48 83.5Z",
    fill: "#D2294B",
    stroke: "#D2294B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.692 70.7745L133.538 76.0574C135.846 78.1436 137 79.1867 137 80.5305C137 81.8742 135.846 82.9173 133.538 85.0035L127.692 90.2865C126.639 91.2387 126.112 91.7149 125.678 91.5166C125.243 91.3182 125.243 90.6016 125.243 89.1682V85.6603C119.946 85.6603 114.207 88.2252 112 92.5C112 78.8205 119.848 75.4007 125.243 75.4007V71.8927C125.243 70.4594 125.243 69.7427 125.678 69.5444C126.112 69.3461 126.639 69.8222 127.692 70.7745Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 119.52V42.4796C149.5 40.2689 151.239 38.5 153.357 38.5H198.309L216.5 57.2015V119.52C216.5 121.731 214.76 123.5 212.643 123.5H153.357C151.24 123.5 149.5 121.732 149.5 119.52Z",
    fill: "white",
    stroke: "#008554"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 94,
    width: 52,
    height: 22,
    rx: 2.68571,
    fill: "#008554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.137 109V100.54H170.933V101.992H166.913V103.972H170.669V105.436H166.913V107.548H170.933V109H165.137ZM171.336 109L174.876 104.296V105.124L171.432 100.54H173.592L175.932 103.768H175.332L177.66 100.54H179.832L176.376 105.124V104.296L179.916 109H177.744L175.32 105.652H175.932L173.52 109H171.336ZM184.335 109.132C183.423 109.132 182.643 108.952 181.995 108.592C181.347 108.232 180.847 107.728 180.495 107.08C180.151 106.424 179.979 105.652 179.979 104.764C179.979 103.876 180.151 103.108 180.495 102.46C180.847 101.812 181.347 101.308 181.995 100.948C182.643 100.588 183.423 100.408 184.335 100.408C184.895 100.408 185.431 100.496 185.943 100.672C186.455 100.848 186.875 101.088 187.203 101.392L186.627 102.868C186.267 102.588 185.903 102.384 185.535 102.256C185.175 102.12 184.795 102.052 184.395 102.052C183.595 102.052 182.987 102.288 182.571 102.76C182.155 103.224 181.947 103.892 181.947 104.764C181.947 105.636 182.155 106.308 182.571 106.78C182.987 107.252 183.595 107.488 184.395 107.488C184.795 107.488 185.175 107.424 185.535 107.296C185.903 107.16 186.267 106.952 186.627 106.672L187.203 108.148C186.875 108.452 186.455 108.692 185.943 108.868C185.431 109.044 184.895 109.132 184.335 109.132ZM188.422 109V100.54H194.218V101.992H190.198V103.972H193.954V105.436H190.198V107.548H194.218V109H188.422ZM195.688 109V100.54H197.548V107.428H201.46V109H195.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.192 52.5996V39.2353L215.82 56.411H202.866C200.853 56.411 199.192 54.7205 199.192 52.5996Z",
    fill: "white",
    stroke: "#008554"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.401 62H159.923C159.413 62 159 62.4133 159 62.9231V67.5696C159 68.0794 159.413 68.4927 159.923 68.4927H205.401C205.911 68.4927 206.324 68.0794 206.324 67.5696V62.9231C206.324 62.4133 205.911 62 205.401 62Z",
    fill: "#008554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 62.9232L159 89.0769C159 89.5867 159.413 90 159.923 90L164.538 90C165.048 90 165.462 89.5867 165.462 89.0769L165.462 62.9232C165.462 62.4134 165.048 62.0001 164.538 62.0001L159.923 62.0001C159.413 62.0001 159 62.4134 159 62.9232Z",
    fill: "#008554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.401 72.7539H159.923C159.413 72.7539 159 73.1672 159 73.677V78.3235C159 78.8333 159.413 79.2466 159.923 79.2466H205.401C205.911 79.2466 206.324 78.8333 206.324 78.3235V73.677C206.324 73.1672 205.911 72.7539 205.401 72.7539Z",
    fill: "#008554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.077 83.5073H160.599C160.089 83.5073 159.676 83.9206 159.676 84.4304V89.0769C159.676 89.5867 160.089 90 160.599 90H206.077C206.586 90 207 89.5867 207 89.0769V84.4304C207 83.9206 206.586 83.5073 206.077 83.5073Z",
    fill: "#008554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.231 62.9232L180.231 89.0769C180.231 89.5867 180.644 90 181.154 90L185.769 90C186.279 90 186.692 89.5867 186.692 89.0769L186.692 62.9232C186.692 62.4134 186.279 62.0001 185.769 62.0001L181.154 62.0001C180.644 62.0001 180.231 62.4134 180.231 62.9232Z",
    fill: "#008554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.539 62.9232L200.539 89.0769C200.539 89.5867 200.952 90 201.462 90L206.077 90C206.587 90 207 89.5867 207 89.0769L207 62.9232C207 62.4134 206.587 62.0001 206.077 62.0001L201.462 62.0001C200.952 62.0001 200.539 62.4134 200.539 62.9232Z",
    fill: "#008554"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9213_1741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 161,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdfToExcel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf_to_excel.cb47d96dacb0b6bb6e7762527a0f00c7.svg";